<div class="navbar-menu background-white py-24 px-10 radius-5">
  <div class="sidenav flex flex-column-nowrap m-0">
    <ul class="n-list-style radius-5 p-0 m-0">
      <ng-container
        *ngFor="let list of currentNavAccessLevel.topNav; let i = index">
        <li class="my-0">
          <button
            class="sidenav__action-button flex align-items-center background-transparent n-border f15 w-100 text-left pl-10 py-10 radius-5"
            [routerLink]="list.route"
            [routerLinkActive]="['active']"
            (click)="toggleMenu()">
            <ps-icon iconClass="mr-10 w-20px h-20px" [srcIcon]="list.icon"></ps-icon>
            <span class="span-text">{{ list.name | translate }}</span>
          </button>
        </li>
      </ng-container>
    </ul>

    <div class="dividerCCC my-16"></div>

    <ul class="nav-admin p-0 m-0 radius-5 n-list-style">
      <ng-container
        *ngFor="let item of currentNavAccessLevel.bottomNav; let j = index">
        <div *ngIf="j > 0" class="dividerCCC mx-10"></div>
        <li
          class="p-10"
          [ngClass]="{
            'pt-16': j === 0,
            'pb-16': j === currentNavAccessLevel.bottomNav.length - 1
          }"
          (click)="inProcess(item)">
          <a
            class="nav-admin__action-button n-decoration f12 block w-100"
            [ngClass]="{ 'n-allowed': !item.enable }"
            [routerLinkActive]="['active']"
            [routerLink]="[item.route]"
            (click)="toggleMenu()">
            <span class="span-text f16">{{ item.name | translate }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
